(() => {
  const match = location.pathname.match(/^(.*\/collections\/[^/]+)(?:\/|$)/);
  if (!match) return;
  const update = () => {
    document.querySelectorAll('main a[href*="/products/"]').forEach((link) => {
      const url = new URL(link.href, location.origin);
      if (url.origin !== location.origin || url.pathname.includes('/collections/')) return;
      const productPath = url.pathname.match(/\/products\/[^/]+$/);
      if (!productPath) return;
      url.pathname = match[1] + productPath[0];
      link.href = url.href;
    });
  };
  update();
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('click', (event) => {
    if (event.target.closest('main a[href*="/products/"]')) update();
  }, true);
})();
